/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";
import { User } from "./user";

export let FORM_ROLES: any[] = [
    {
        label: 'OWN',
        role: 'ASSIGNOR'
    },
    {
        label: 'ACCESS',
        role: 'ASSIGNEE'
    },
    {
        label: 'EDITOR',
        role: 'EDIT'
    },
    {
        label: 'VIEW',
        role: 'VIEWER'
    }
];

export class FormUser implements Serializable<FormUser> {


    userId: number;
    user: User;
    role: string;
    parentRole: string;
    assignmentId: number;
    isActive: boolean;
    unassign: boolean

    constructor(input?: any) {
        !!input && this.deserialize(input);
    }

    deserialize(input: any) {
        !!input.userId && (this.userId = input.userId);
        !!input.user && (this.user = new User().deserialize(input.user))
        !!input.role && (this.role = input.role);
        !!input.parentRole && (this.parentRole = input.parentRole);
        !!input.assignmentId && (this.assignmentId = input.assignmentId);
        this.isActive = input.isActive;
        this.unassign = input.unassign
        !!this.user && (this.isActive = this.user.isActive);
        !!this.user && (this.unassign = input.unassign);

        return this;
    }

    //Get the proper role, regardless of the format (role/permission)
    getRole = (frmRoles?): string => {
        let callerRole;
        let fr = !!frmRoles ? frmRoles : FORM_ROLES;
        let rObj = (!this.role && null) ||
            (fr.find(role => role.label.toUpperCase() == this.role.toUpperCase()) ||
                fr.find(role => role.role.toUpperCase() == this.role.toUpperCase()));
        if (rObj) {
            if (!!rObj['parentRole']) {
                callerRole = rObj['parentRole'];
            } else {
                callerRole = rObj['role'];
            }
        }
        return callerRole;
    }



    //Get the proper permission, regardless of the format (role/permission)
    getPermission = (frmRoles?): string => {
        let fr = !!frmRoles ? frmRoles : FORM_ROLES;
        let roleBase = fr.find(role => role.label.toUpperCase() == this.role.toUpperCase());
        let permBase = fr.find(role => role.role.toUpperCase() == this.role.toUpperCase());

        return (!this.role && null)
            || (!!roleBase && roleBase.role)
            || (!!permBase && permBase.role)
            || null;
    }

}
